/**
 * Foundation/Core — Suite Applications URL resolver
 *
 * Single Source of Truth per gli URL delle applicazioni della Gruppo Impresa Suite.
 * Utilizzabile da qualsiasi Product Pack (GI Presenze, GI Clienti, GI Studio,
 * GI Fatturazione, GI Finance, GI Connect, AI Assistant, ...).
 *
 * Espone:
 *  - `isLocalSuiteHost(hostname)`: true se l'host e' locale (loopback, .local, RFC1918).
 *  - `getSuiteApplicationUrls(locationLike?)`: mappa key -> URL delle app Suite in base
 *    all'ambiente rilevato (locale vs produzione). Accetta un `Location-like` per
 *    facilitare i test o cast di ambiente da altri pack.
 *
 * Le porte locali (8001/8002/8003) e i domini pubblici (`*.gruppoimpresa.org`) sono
 * attributi infrastrutturali dell'intera Suite, non di un singolo Product Pack.
 */
const PRIVATE_IPV4 = /^(10\.|127\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.)/;

export function isLocalSuiteHost(hostname = "") {
  const normalized = String(hostname).toLowerCase();
  return normalized === "localhost"
    || normalized === "::1"
    || normalized.endsWith(".local")
    || PRIVATE_IPV4.test(normalized);
}

export function getSuiteApplicationUrls(locationLike = window.location) {
  const hostname = locationLike?.hostname || "localhost";

  if (isLocalSuiteHost(hostname)) {
    const host = hostname.includes(":") ? `[${hostname}]` : hostname;
    return {
      studio: `http://${host}:8001`,
      presenze: `http://${host}:8002`,
      pagamenti: `http://${host}:8003`,
    };
  }

  return {
    studio: "https://studio.gruppoimpresa.org",
    presenze: "https://presenze.gruppoimpresa.org",
    pagamenti: "https://pagamenti.gruppoimpresa.org",
  };
}
